// CacheKey 503b0293beed27a5e2fe5da0b931bb70
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-JACK_HUGHSTON": {
    simple_form: {
      labels: {
        encounter: {
          arrival_date: "Appointment Date",
          risk_score_1_on_discharge: "ASA",
          risk_score_2_on_discharge: "Blood Charge",
          risk_score_3_on_discharge: "Recorded Value"
        },
        patient: {
          polst: "Received TXA",
          medicaid_id: "Patient Number"
        }
      }
    }
  }
}

